export default __webpack_public_path__ + "static/media/phone.c358eb1e.png";